import { type ApolloQueryResult } from '@apollo/client/core/index.js'; // NOSONAR included by parent project.
import { html, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { PopIvsApiBaseComponent } from '../../base/ivs-api-base/ivs-api-base.js';
import { Constants } from './product-tile-etf.constants.js';
import type { ProductTileEtfContentObject } from './product-tile-etf.model.js';
import style from './product-tile-etf.scss?inline';
/**
 * Queries the IVS endpoint for one ETF
 * @tag pop-product-tile-etf-component
 * @attribute { ProductTileEtfContentObject } [data-component-object] ProductTileEtf content object
 */
@customElement(Constants.TAG_NAME)
export class PopProductTileEtfComponent extends PopIvsApiBaseComponent {
  static get styles() {
    return [...super.styles, unsafeCSS(style)];
  }
  /**
   * @internal
   */
  tagName = Constants.TAG_NAME;

  /**
   * The fragment used to fetch the data for the component.
   */
  @property({
    attribute: Constants.DATA_URL_ROOT,
    type: String,
  })
  urlRoot = '';

  constructor() {
    super();
    this.queryType = 'ETF';
    this.apiService.processResponse = this.processResponse;
  }

  /**
   * ProductTileEtf content object
   */
  componentObject?: ProductTileEtfContentObject;

  /**
   * Converts the API response into the component object expected
   *  by product-tile-ui
   * @internal
   */
  override processResponse = ({ data, errors }: ApolloQueryResult<any>) => {
    if (errors) {
      console.error(Constants.LOG_PREFIX, errors);
      return;
    }
    //if data.exchangeTradedFund is undefined or null
    if (!data?.exchangeTradedFund) {
      console.error(
        Constants.LOG_PREFIX,
        'No data found for exchangeTradedFund',
      );
      return;
    }
    this.componentObject = {
      ...data.exchangeTradedFund,
      urlRoot: this.urlRoot || this.componentObject?.urlRoot,
    };
  };

  render() {
    if (this.componentObject) {
      return this.renderComponent(html`
        <pop-product-tile-ui-component
          data-component-object="${JSON.stringify(this.componentObject)}"
        >
          <div slot="footer"><slot name="action"></slot></div>
        </pop-product-tile-ui-component>
      `);
    }
    return html``;
  }
}
